module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/RECOMMENDED_FOR_YOU.dccf8058.svg";